<ng-content></ng-content>
<span #spacer class="plc-action-buttons__spacer"> </span>
